"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PdaCheckboxes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rcDialog = _interopRequireDefault(require("rc-dialog"));

require("rc-dialog/assets/index.css");

var _index2 = _interopRequireDefault(require("./PdaContract/index.js"));

var _index3 = _interopRequireDefault(require("./PdaPolitics/index.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    p {\n        margin-bottom: 16px;\n    }\n\n    ul {\n        padding-left: 40px;\n        margin-bottom: 16px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var DialogContent = _styledComponents["default"].div(_templateObject());

var PdaCheckboxes = /*#__PURE__*/function (_Component) {
  _inherits(PdaCheckboxes, _Component);

  var _super = _createSuper(PdaCheckboxes);

  function PdaCheckboxes(props) {
    var _this;

    _classCallCheck(this, PdaCheckboxes);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "togglePoliticsModal", function (e) {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      _this.setState({
        politics: !_this.state.politics
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleContractModal", function (e) {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      _this.setState({
        contract: !_this.state.contract
      });
    });

    _this.state = {
      politics: false,
      contract: false
    };
    return _this;
  }

  _createClass(PdaCheckboxes, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
        name: "agreement",
        component: this.props.Checkbox,
        text: this.props.agreementLabel
      }), /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
        name: "contract",
        component: this.props.Checkbox,
        text: this.props.contractLabel,
        toggleModal: this.toggleContractModal
      }), /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
        name: "politics",
        component: this.props.Checkbox,
        text: this.props.politicsLabel,
        toggleModal: this.togglePoliticsModal
      }), /*#__PURE__*/_react["default"].createElement(_rcDialog["default"], {
        title: this.props.contractTitle,
        animation: "fade",
        maskAnimation: "fade",
        style: {
          width: '80%'
        },
        visible: !!this.state.contract,
        onClose: this.toggleContractModal
      }, /*#__PURE__*/_react["default"].createElement(DialogContent, null, /*#__PURE__*/_react["default"].createElement(_index2["default"], null))), /*#__PURE__*/_react["default"].createElement(_rcDialog["default"], {
        title: this.props.politicsTitle,
        visible: !!this.state.politics,
        animation: "fade",
        maskAnimation: "fade",
        style: {
          width: '80%'
        },
        onClose: this.togglePoliticsModal
      }, /*#__PURE__*/_react["default"].createElement(DialogContent, null, /*#__PURE__*/_react["default"].createElement(_index3["default"], null))));
    }
  }]);

  return PdaCheckboxes;
}(_react.Component);

exports.PdaCheckboxes = PdaCheckboxes;